/**
 * ═════════════════════════════════════════════════════════════════════════════
 * `autofocus="true"` as a real ATTRIBUTE — a ref callback, not a prop.
 *
 * React's `autoFocus` prop focuses the element imperatively and deliberately
 * does NOT emit the attribute. That is a problem here because the attribute is
 * a SELECTOR, not a hint: the popup Enter handlers key off it.
 *   · project board  — `hooks/usePopupKeys.ts`
 *   · CMS Admin      — `pages/cms-admin/useCmsFormControls.ts`, reproducing
 *                      `cms.main.js:53-56`:
 *                        $('.popup-wrapper.active button[autofocus="true"]').click()
 * Without the literal attribute, pressing Enter in a popup silently does
 * nothing.
 *
 * ★ PROMOTED OUT OF `pages/project-board/projectBoardUtils.ts` IN PHASE 7 · T2
 * (2026-08-06). The CMS `network` screen's add/edit-user popup needs it for its
 * Done button, and importing a project-board util from a CMS screen puts the
 * helper on the wrong side of a page boundary — especially since the consumer
 * that makes it load-bearing is the CMS shell's OWN Enter handler. Same reasoning
 * (and same shape) as T1's `useBootstrapDropdown` promotion. Behaviour is
 * unchanged: a move plus import rewrites, no edit to the one-line body.
 * ═════════════════════════════════════════════════════════════════════════════
 */
export const autofocusAttr = (el: HTMLButtonElement | null): void => {
  el?.setAttribute('autofocus', 'true');
};
